import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';
import { useAssignDesignInputVerification } from '../Product.hooks';
import {
  BaseProductAssignDialogProps,
  ProductVerification
} from '../Product.interface';
import AssignVerificationDialog from './AssignVerificationDialog';

export type DesignInputAssignVerificationDialogProps =
  BaseProductAssignDialogProps<'designInputId'>;

const DesignInputAssignVerificationDialog: React.FC<DesignInputAssignVerificationDialogProps> =
  (props: DesignInputAssignVerificationDialogProps) => {
    const {
      open,
      productId,
      designInputId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductDesignInput,
      isAssigning,
      error: assignError,
      assignVerifications
    } = useAssignDesignInputVerification(productId, designInputId);

    useEffect(() => {
      if (updatedProductDesignInput) {
        onAssigned?.(updatedProductDesignInput);
      }
    }, [updatedProductDesignInput]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
    }, [assignError]);

    return (
      <AssignVerificationDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for Verifications to assign to the ${getProductEntityName(
          'designInput'
        )}.`}
        onSubmit={(verifications: ProductVerification[]) => {
          assignVerifications({
            verificationIds: verifications.map(
              (verification: ProductVerification) => verification.id
            )
          });
        }}
      />
    );
  };

export default DesignInputAssignVerificationDialog;
